<template>
  <div class="reward-details">
    <div
      class="reward-details-header expander"
      role="button"
      tabindex="0"
      :aria-label="`Reward Details ${isExpanded ? 'Expanded' : 'Collapsed'}`"
      :aria-expanded="isExpanded"
      :aria-controls="expanderId"
      @click="expandToggle"
      @keyup.enter="expandToggle"
    >
      <h3 class="title">Reward Details</h3>
      <div class="expand-collapse">
        <i
          class="material-symbols-outlined fill"
          aria-hidden="true"
          :data-icon="isExpanded ? 'expand_less' : 'expand_more'"
        ></i>
      </div>
    </div>
    <div :id="expanderId" :aria-hidden="!isExpanded" class="reward-details-content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Expander for rewards.
 */
import { computed, ref } from 'vue'

/** PROPS **/
const props = defineProps<{
  rewardId: number
}>()

/** STATE **/
const isExpanded = ref(false)

/** COMPUTED **/
const expanderId = computed(() => `reward-details-content-${props.rewardId}`)

/** METHODS **/
function expandToggle() {
  isExpanded.value = !isExpanded.value
}
</script>
